// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"c96a2500","402":"ce8e6803","612":"75feef0f","673":"aa0f8ff1","854":"a615f779","903":"a3ed5294","924":"4cd1de16"}[chunkId] + ".chunk.js";
};